import { Button } from 'antd';
import type { ButtonProps } from 'antd/lib/button';
import { type FC, useMemo, useState } from 'react';

export type ButtonSettings = {
    disabled?: boolean;
};
const useLoadingButton = () => {
    const [loading, setLoading] = useState(false);

    const LoadingButton = useMemo(() => {
        const settings: ButtonSettings = {};
        if (loading) {
            settings.disabled = true;
        }

        const Component: FC<ButtonProps> = ({ children, ...props }) => (
            <Button {...props} {...settings}>
                {children}
            </Button>
        );

        return Component;
    }, [loading]);

    return useMemo(
        () => ({
            setLoading,
            LoadingButton,
        }),
        [LoadingButton]
    );
};

export default useLoadingButton;
